// extracted by mini-css-extract-plugin
export default {"drawer":"FilterSidebar_drawer__KMpXb","drawerBox":"FilterSidebar_drawerBox__g4FtQ"};